import React from 'react';
import { number } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { s_star } from '@fiverr-private/fit/icons';

import './style.scss';

const Rating = ({ rating, ratingCount }) => {
    const count = ratingCount < 1000 ? ratingCount : '1k+';

    return (
        <div className="rating tbody-6">
            <Icon className="rating-star" size={10}>
                {s_star}
            </Icon>
            <p className="rating-title text-body-3">
                <strong>{rating.toFixed(1)}</strong> ({count})
            </p>
        </div>
    );
};

Rating.propTypes = {
    rating: number,
    ratingCount: number,
};

export default Rating;
